import Agendamento from "../../Components/Banner-Agendamentos/BanAgendamentos";
import Footer from "../../Components/Footer/Footer";
import TecnologiasPage from "../../Components/Tecnologias/Tecnologias-Page";

function Tecnologias () {
    return (
        <>
            <div id="Tecnologias">
                <TecnologiasPage/>    
            </div>
            <div id="banner-agendamento">
                <Agendamento />
            </div>
            <div id="footer">
                <Footer />
            </div>
        </>
    );
}

export default Tecnologias;